export default __webpack_public_path__ + "static/media/Download.3274cb82.svg";